<template>
  <div class="row">
    <div class="col-md-4 border-right">
      <div>
        <custom-drop-down
          v-model="selectedRol"
          :options="availableRoles"
          label="Rol:"
          fieldkey="id"
          fieldname="name"
          placeholder="Seleccione"
          :error="requiredRol"
          :disabled="readOnly"
          custom-error-msg="Debe seleccionar un rol"
          @input="onChangeRol"
        />
        <div class="row mt-3">
          <div class="col-md-8 text-left">
            <custom-link
              v-if="!showUserSelection"
              class="ml-n1"
              text="Seleccionar todos los roles"
              icon="fas fa-plus-circle"
              @click="selectAllRoles"
            />
          </div>
          <div class="col-md-4 text-right">
            <ActionButton
              v-if="!showUserSelection"
              variant="success"
              text="Añadir Rol"
              i="fas fa-file-plus"
              :disabled="readOnly"
              @click="select"
            />
          </div>
        </div>
      </div>
      <div v-if="showUserSelection">
        <custom-drop-down
          v-model="selectedUser"
          :options="availableUsers"
          label="Usuario:"
          fieldkey="id"
          fieldname="name"
          placeholder="Seleccione"
          :error="requiredUser"
          custom-error-msg="Debe seleccionar un usuario"
          :disabled="!selectedRol || readOnly"
        />
        <div class="row mt-3">
          <div class="col-md-8 text-left">
            <custom-link
              class="ml-n1"
              text="Seleccionar todos los usuarios"
              icon="fas fa-plus-circle"
              @click="selectAllUsers"
            />
          </div>
          <div class="col-md-4 text-right">
            <ActionButton
              variant="success"
              text="Añadir Usuario"
              i="fas fa-file-plus"
              :disabled="readOnly"
              @click="selectUser"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-9">
          <CustomChipsGroup
            :title="
              showUserSelection
                ? 'Usuario(s) Seleccionados'
                : 'Rol(es) Seleccionados'
            "
            :selected-items="showUserSelection ? selectedUsers : selectedRoles"
            :no-wrap="true"
            no-background
            :object-text="'name'"
            class="mt-n3"
            :disabled="readOnly"
            @itemMarkedForDeletion="unSelect"
          />
          <Error
            v-if="showError"
            :message="
              'Favor de seleccionar el(los) ' +
                (showUserSelection ? 'usuario(s)' : 'rol(es)') +
                ' que visualizará(n) el mensaje'
            "
            variant="no-border"
          />
        </div>
        <div class="col-md-3">
          <custom-link
            :text="
              'Remover todos los ' +
                (showUserSelection ? 'usuarios' : 'roles') +
                ' seleccionados'
            "
            icon="fas fa-minus-circle"
            color="red"
            class="justify-content-end"
            @click="unSelectAll"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomLink from '@/components/common/CustomLink';
import ActionButton from '@/components/common/ActionButton';
import CustomChipsGroup from '@/components/common/CustomChipsGroup';
import Error from '@/components/common/Error';
export default {
  name: 'UserRoleSelection',
  data: () => ({
    selectedRol: null,
    availableRoles: [],
    selectedUser: null,
    availableUsers: [],
    requiredRol: false,
    requiredUser: false,
  }),
  components: {
    CustomDropDown,
    CustomLink,
    ActionButton,
    CustomChipsGroup,
    Error,
  },
  props: {
    roleList: {
      type: Array,
      default: () => [],
    },
    userList: {
      type: Array,
      default: () => [],
    },
    selectedRoles: {
      type: Array,
      default: () => [],
    },
    selectedUsers: {
      type: Array,
      default: () => [],
    },
    showError: {
      type: Boolean,
      default: () => false,
    },
    //Controla visibilidad de seleccion de usuario
    showUserSelection: {
      type: Boolean,
      default: () => true,
    },
    readOnly:{
      type: Boolean,
      default: () => false
    },
  },
  watch: {
    roleList() {
      this.loadAvailableRol('id');
    },
    selectedRoles() {
      this.loadAvailableRol('id');
    },
    userList() {
      this.loadAvailableUsers('id');
    },
    selectedUsers() {
      this.loadAvailableUsers('id');
    },
  },
  methods: {
    unSelect(item) {
      if (this.showUserSelection) {
        this.$emit('on-unselect-user', item);
      } else {
        this.$emit('on-unselect-role', item);
      }
    },
    unSelectAll() {
      if(this.readOnly) return;
      this.$emit('on-unselect-all', this.showUserSelection);
    },
    async select() {
      if (this.readOnly) return;
      if (!this.selectedRol?.id) {
        this.requiredRol = true;
        return;
      }
      this.$emit('on-select-rol', false, { ...this.selectedRol });
      this.selectedRol = {};
      this.requiredRol = false;
    },
    async selectUser() {
      if (this.readOnly) return;
      if (!this.selectedUser?.id) {
        this.requiredUser = true;
        return;
      }
      this.$emit('on-select-user', false, { ...this.selectedUser });
      this.selectedUser = {};
      this.requiredUser = false;
    },
    selectAllRoles() {
      if(this.readOnly) return;
      this.$emit('on-select-rol', true, this.availableRoles);
    },
    selectAllUsers() {
      if(this.readOnly) return;
      this.$emit('on-select-user', true, this.availableUsers);
    },
    loadAvailableRol(propName) {
      this.availableRoles = _.differenceBy(
        this.roleList,
        this.selectedRoles,
        propName
      );
    },
    loadAvailableUsers(propName) {
      this.availableUsers = _.differenceBy(
        this.userList,
        this.selectedUsers,
        propName
      );
    },
    async onChangeRol(item) {
      if (this.showUserSelection) {
        this.selectedUser = null;
        this.$emit('on-change-rol', item);
      }
    },
  },
  mounted() {
    this.loadAvailableRol('id');
  },
};
</script>
